<template>
  <div class="vehicle-management">
    <div>
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
        size="small"
      >
        <el-form-item label="使用人">
          <el-input
            v-model="formInline.borrowManName"
            placeholder="使用人"
          ></el-input>
        </el-form-item>
        <el-form-item label="商机号">
          <el-select
            v-model="formInline.saleChanceId"
            placeholder="请输入商机号"
            :loading="loading"
            filterable
            clearable
          >
            <el-option
              v-for="item in projects"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      stripe
      v-model="tableData"
      style="width: 100%"
      :row-style="{ height: '58px' }"
      height="calc(100vh - 280px)"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <el-table-column prop="id" label="id" width="60px" align="center">
      </el-table-column>
      <el-table-column prop="carName" label="车辆型号" align="center">
      </el-table-column>
      <el-table-column prop="carNumber" label="车牌号" align="center">
      </el-table-column>
      <el-table-column prop="borrowManName" label="使用人" align="center">
      </el-table-column>
      <el-table-column prop="carPurpose" label="车辆用途" align="center">
        <template slot-scope="scope">
          <span>{{
            scope.row.carPurpose == "yw" ? "业务用车" : "行政用车"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="car_usetime"
        label="使用日期"
        width="280px"
        align="center"
      
      min-width="130"
      
      :formatter="dateTimeTwoLine"
      class-name="cell-two-line"
      >
        <template slot-scope="scope">
          <span
            >{{ scope.row.borrowBeginTime
            }}{{ scope.row.borrowBeginPeriodName }} 到
            {{ scope.row.borrowEndTime
            }}{{ scope.row.borrowEndPeriodName }}</span
          >
        </template>
      </el-table-column>
      <el-table-column prop="saleChanceId" label="商机号" align="center">
      </el-table-column>
      <el-table-column prop="borrowManDeptName" label="用车部门" align="center">
      </el-table-column>
      <el-table-column prop="borrowReason" label="借车原由" align="center">
      </el-table-column>
      <el-table-column prop="borrowReason" label="状态" align="center">
      </el-table-column>
      <el-table-column
        fixed="right"
        prop="operate"
        label="操作"
        align="center"
        width="180px"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            :disabled="scope.row.flag != 0 && scope.row.carPurpose == 'xz'"
            @click="printRow(scope.row)"
            >打印</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="formInline.page"
      :limit.sync="formInline.limit"
      @pagination="getList"
    />
    <!-- <el-dialog title="" :visible.sync="dialogVisible" width="42%"> -->
    <vue-easy-print ref="listPrint">
      <h2 class="table-text">江西云擎科技有限公司商务车领用单</h2>
      <table class="table table-bordered">
        <tbody>
          <tr>
            <td>领用部门</td>
            <td>
              {{ OrderPrinting.borrowManDeptName }}
            </td>
            <td>领用日期</td>
            <td>{{ OrderPrinting.currentTime }}</td>
          </tr>
          <tr>
            <td>出发时间</td>
            <td>
              {{ OrderPrinting.borrowBeginTime
              }}{{ OrderPrinting.borrowBeginPeriodName }}
            </td>
            <td>返回时间</td>
            <td>
              {{ OrderPrinting.borrowEndTime
              }}{{ OrderPrinting.borrowEndPeriodName }}
            </td>
          </tr>
          <tr>
            <td>商 机 号</td>
            <td>
              {{
                OrderPrinting.saleChanceId ? OrderPrinting.saleChanceId : "/"
              }}
            </td>

            <td>金 额（元）</td>
            <td>{{ OrderPrinting.carFee }}</td>
          </tr>
          <tr>
            <td>申 请 人</td>
            <td>
              {{ OrderPrinting.borrowManName }}
            </td>
            <td>审 批 人</td>
            <td>
              {{
                OrderPrinting.dealUserName ? OrderPrinting.dealUserName : "无"
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </vue-easy-print>
    <!-- <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="printRow"
            >确 定</el-button
          >
        </span> -->
    <!-- </el-dialog> -->
  </div>
</template>

<script>
import {
  getneedExamine,
  approvalstageList,
  getProjects,
} from "@/api/car/BorrowCar.js";
import vueEasyPrint from "vue-easy-print";
export default {
  components: {
    vueEasyPrint,
  },

  data() {
    return {
      total: 1, //总条目数
      loading: false,
      options: [],
      dialogVisible: false,
      projects: [],
      OrderPrinting: {
        dealUserName: "",
      },
      formInline: {
        page: 1,
        limit: 10,
        func: 99,
        borrowManName: "",
        region: "",
        saleChanceId: null,
      },
      tableData: [],
    };
  },
  created() {
    this.getList();
    this.getProject();
  },
  methods: {
    /** 查询用户列表 */
    async getList() {
      this.loading = true;
      let { data, count } = await getneedExamine(this.formInline);
      this.tableData = data;
      this.total = count;
      this.loading = false;
    },
    //商机
    async getProject() {
      //获取项目
      getProjects().then((resp) => {
        this.projects = resp.data;
      });
    },
    //用车申请驳回
    printRow(row) {
      this.dialogVisible = true;
    },
    async printRow(row) {
      // this.dialogVisible = true;
      this.OrderPrinting = row;
      this.OrderPrinting.currentTime = new Date().toLocaleString();
      this.OrderPrinting.dealUserName = "";
      let { data } = await approvalstageList(row.applyCode);
      data.map((item) => {
        this.OrderPrinting.dealUserName +=
          data.length > 1 ? item.dealUserName + "、" : item.dealUserName;
      });
      this.$nextTick(() => {
        this.$refs.listPrint.print();
      });
    },
    async onSubmit() {
      this.formInline.page = 1;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.table-text {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  margin: 20px;
}
.table-bordered {
  border: 3px solid purple;
  border-collapse: collapse;
  text-align: center;
  margin: 0 auto;
  td {
    border: 1px solid black;
    padding: 20px 40px;
  }
}
@page {
  size: auto A4 landscape;

  margin: 3mm;
}
</style>
